import React from 'react';
import proptypes from 'prop-types';
const { string } = proptypes;

import { Alert } from '@one-thd/sui-atomic-components';

import { WARNING_MESSAGE } from '../../utils/constants';

import './warning-message.scss';

export const WarningMessage = ({ message }) => {
  return (
    <Alert
      status="error"
    >
      { message }
    </Alert>
  );
};

WarningMessage.propTypes = {
  message: string
};

WarningMessage.defaultProps = {
  message: WARNING_MESSAGE,
};
